import { IEntity } from "./Entity";
import { IUser } from "./User";
import { IPartnerOrganisation } from "./PartnerOrganisation";
import { IPartnerOrganisationRiskMitigationAction } from "./PartnerOrganisationRiskMitigationAction";
import { IPartnerOrganisationRiskRiskType } from "./PartnerOrganisationRiskRiskType";
import { IReportingEntity, ReportingEntity } from "./ReportingEntity";
import { IPartnerOrganisationRiskUpdate } from "./PartnerOrganisationRiskUpdate";

export interface IPartnerOrganisationRisk extends IReportingEntity {
    RiskCode: string;
    PartnerOrganisationID: number | null;
    RiskOwnerUserID: number | null;
    BeisRiskOwnerUserID: number | null;
    RiskEventDescription: string;
    RiskCauseDescription: string;
    RiskImpactDescription: string;
    UnmitigatedRiskProbabilityID: number | null;
    UnmitigatedRiskImpactLevelID: number | null;
    TargetRiskProbabilityID: number | null;
    TargetRiskImpactLevelID: number | null;

    BEISUnmitigatedRiskProbabilityID: number | null;
    BEISUnmitigatedRiskImpactLevelID: number | null;
    BEISTargetRiskProbabilityID: number | null;
    BEISTargetRiskImpactLevelID: number | null;

    RiskAppetiteID: number | null;
    BeisRiskAppetiteID: number | null; // Obsolete? Replaced with calculated appetite based on risk types
    DepartmentalObjectiveID: number | null;
    RiskIsOngoing: boolean;
    RiskProximity: Date | null;
    PartnerOrganisation?: IPartnerOrganisation;
    RiskOwnerUser?: IUser;
    BeisRiskOwnerUser?: IUser;
    PartnerOrganisationRiskMitigationActions?: IPartnerOrganisationRiskMitigationAction[];
    PartnerOrganisationRiskRiskTypes?: IPartnerOrganisationRiskRiskType[];
    UnmitigatedRiskProbability?: IEntity;
    UnmitigatedRiskImpactLevel?: IEntity;
    TargetRiskProbability?: IEntity;
    TargetRiskImpactLevel?: IEntity;

    BEISUnmitigatedRiskProbability?: IEntity;
    BEISUnmitigatedRiskImpactLevel?: IEntity;
    BEISTargetRiskProbability?: IEntity;
    BEISTargetRiskImpactLevel?: IEntity;

    RiskAppetite?: IEntity;
    BeisRiskAppetite?: IEntity;

    PartnerOrganisationRiskUpdates?: IPartnerOrganisationRiskUpdate[];
}

export class PartnerOrganisationRisk extends ReportingEntity implements IPartnerOrganisationRisk {
    public RiskCode = '';
    public PartnerOrganisationID = null;
    public RiskOwnerUserID = null;
    public BeisRiskOwnerUserID = null;
    public RiskEventDescription = '';
    public RiskCauseDescription = '';
    public RiskImpactDescription = '';
    public UnmitigatedRiskProbabilityID = null;
    public UnmitigatedRiskImpactLevelID = null;
    public TargetRiskProbabilityID = null;
    public TargetRiskImpactLevelID = null;

    public BEISUnmitigatedRiskProbabilityID = null;
    public BEISUnmitigatedRiskImpactLevelID = null;
    public BEISTargetRiskProbabilityID = null;
    public BEISTargetRiskImpactLevelID = null;

    public RiskAppetiteID = null;
    public BeisRiskAppetiteID = null;
    public DepartmentalObjectiveID = null;
    public RiskIsOngoing = false;
    public RiskProximity = null;
    public PartnerOrganisationRiskRiskTypes = [];
    public Contributors = [];
}